import { api } from "@/shared/api";

// FSD entities/media-bgm(2026-09-07)— 背景音乐(平台曲库 + 自传 mp3)。
//
// 视频线(features/video/api/videoService.ts)与分身线(features/digital-human)出片都要挂配乐,
// 两边共同的后端资产是同一套曲库接口。features 之间禁止互相 import(ADR-0013 单向核心,
// eslint no-restricted-imports 会拦),跨 feature 共享业务能力要下沉到这一层 —— 与
// `entities/dh-profile` 从 `features/digital-human` 抽出的那批(packs W2)同一条规矩。
//
// ★不改 features/video:那边的 videoService 已经有自己的同名方法在跑,本模块只是给
//   digital-human 一条不违反单向核心的消费路径,两处实现各自独立(都是薄薄两个 api 调用,
//   不值得为了 DRY 去动视频线正在用的代码)。

const BASE = "/video";

/** 平台曲库曲目。url = 试听地址(presign,可能为空)。 */
export interface BgmDto {
  id: number;
  name: string;
  durationSec: number;
  url?: string;
  tags?: string[];
  enabled?: boolean;
  sortOrder?: number;
}

export const bgmService = {
  /** 平台曲库(租户可见、已启用的曲目)。 */
  listBgms: () => api.get<BgmDto[]>(`${BASE}/bgms`),

  /** 自传 mp3(≤10MB),返 objectKey(建任务时原样带回)+ url(试听)。 */
  uploadCustomBgm: (file: File): Promise<{ objectKey: string; url: string; sizeBytes: string }> => {
    const form = new FormData();
    form.append("file", file);
    return api.post<{ objectKey: string; url: string; sizeBytes: string }>(
      `${BASE}/uploads/bgm`,
      form
    );
  },
};
